module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10074.3dbc199d.jpg";